<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <b-row class="justify-content-start">
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button class="btnFilter" :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5">
          <security-list typeList="configurationSMIME" :key="refreshKey" :spinnerActivated="activateSpinner"></security-list>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import SecurityList from '@/pages/security/SecurityList.vue'
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'SMIMEPage',
  components: {
    'page-outline': PageOutline,
    'security-list': SecurityList
  },
  props: {
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    canSeeSMIME () {
      return this.$engine.rights.rightIs('configsmime_consult', true)
    }
  },
  data () {
    return {
      activateSpinner: false,
      listTitle: '',
      refreshKey: false
    }
  },
  created () {
    this.listTitle = this.$i18n.t('common.security.smime_consult_list')
    if (this.id !== '-1') {
      this.tabName = parseInt(this.id)
    }
  },
  methods: {
    onRefresh () {
      this.refreshKey = !this.refreshKey
    }
  }
}
</script>
